import { TenantEntity } from '../TenantEntity'

export class CargoBulkDetail extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get insideQuantity() {
    return this._data.insideQuantity
  }
  set insideQuantity(insideQuantity) {
    this._data.insideQuantity = insideQuantity || 0
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    this._data.weight = weight || 0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    this._data.cubage = cubage || 0
  }
  get sizeLength() {
    return this._data.sizeLength
  }
  set sizeLength(sizeLength) {
    this._data.sizeLength = sizeLength || 0
  }
  get sizeWidth() {
    return this._data.sizeWidth
  }
  set sizeWidth(sizeWidth) {
    this._data.sizeWidth = sizeWidth || 0
  }
  get sizeHeight() {
    return this._data.sizeHeight
  }
  set sizeHeight(sizeHeight) {
    this._data.sizeHeight = sizeHeight || 0
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
}
